export default "__VITE_ASSET__CnCDOudI__"